import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import SubmitButtonComponent from 'webapp/components/submit-button';

type Args = Record<string, never>;

export default class BillingAiCreditsWarningBannerComponent extends Component<Args> {
	@service('billing') declare billingService: Service.Billing;

	get creditsUsed(): string {
		return this.billingService.aiCreditsCurrent.toLocaleString('en-US');
	}

	get creditsTotal(): string {
		const total =
			(this.billingService.getFeatureValue(BillingFeature.AI_CREDITS) as number) || 0;
		return total.toLocaleString('en-US');
	}

	get resetDate(): string {
		return this.billingService.aiCreditsResetDate;
	}

	@action
	addCredits(): void {
		this.billingService.handleLimitations(BillingFeature.AI_CREDITS);
	}

	<template>
		<div class="notification-container ai-credits-warning-notification">
			<div class="ai-credits-warning-notification__icon">
				<CommonUiIconComponent @name="Ai" @size="md" />
			</div>

			<div class="ai-credits-warning-notification__body">
				<div class="ai-credits-warning-notification__title">
					You're out of AI credits —
					{{this.creditsUsed}}
					of
					{{this.creditsTotal}}
					used
				</div>
				<div class="ai-credits-warning-notification__text">
					Genie is paused until
					{{this.resetDate}}. Extra credits start working immediately and renew each
					month; you can remove them again at any time.
				</div>
			</div>

			<SubmitButtonComponent
				@text="Add credits"
				@noDelay={{true}}
				@onTrigger={{this.addCredits}}
			/>
		</div>
	</template>
}
